import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import MarketItem, { Column } from 'components/pages/market/home/MarketItem';
import MarketHomeFilterBar from './MarketHomeFilterBar';
import { FilterType, MOCK_USER_ID } from './MarketHome';
import useMarket from 'hooks/useMarket';
import useScroll from 'hooks/common/useScroll';

function MarketListView({ market }) {
   // states
   const [marketItems, setMarketItems] = useState([]);
   const [page, setPage] = useState(0);
   const [totalCount, setTotalCount] = useState(0);
   const [isEndFetch, setEndFetch] = useState(false);
   const filterRef = useRef(Object.keys(FilterType)[0]);
   const [filterType, setFilterType] = useState(Object.keys(FilterType)[0]);

   // handlers
   const handleFilterType = filterType => setFilterType(filterType);
   const callFetchMarkets = _page =>
      fetchMarkets({ market: market, sort: filterType, page: _page });
   const resetAllStates = () => {
      setPage(0);
      setMarketItems([]);
      setEndFetch(false);
   };

   // hooks
   const { markets, totalMarketsCount, fetchMarkets, resetMarketItems } = useMarket();
   const isScrollBottom = useScroll();

   useEffect(() => {
      callFetchMarkets(page);
      return () => {
         resetMarketItems();
      }
   }, []);

   useEffect(() => {
      if (isScrollBottom && !isEndFetch) {
         callFetchMarkets(page);
      }
   }, [isScrollBottom]);

   useLayoutEffect(() => {
      if (!markets) return;
      const isSameObjs =
         JSON.stringify(markets.map(m => m.whole_id)) ===
         JSON.stringify(marketItems.map(m => m.whole_id).slice(0, 5));
      if (isEndFetch || isSameObjs) return;
      if (markets.length < 5) setEndFetch(true);
      setMarketItems([...marketItems, ...markets]);
      setTotalCount(totalMarketsCount);
      setPage(page + 1);
   }, [markets]);

   useEffect(() => {
      const oldValue = filterRef.current;
      const newValue = filterType;
      if (oldValue === newValue) return;
      resetAllStates();
      callFetchMarkets(0);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      filterRef.current = filterType;
   }, [filterType]);

   return (
      <MarketListViewWrapper>
         <MarketHomeFilterBar
            resultsCount={totalCount}
            filterType={filterType}
            handleFilterType={handleFilterType}
         />
         {marketItems &&
            marketItems.map(item => {
               return <MarketItem key={`${market}-${item.whole_id}`} item={item} />;
            })}
      </MarketListViewWrapper>
   );
}

export default React.memo(MarketListView);

export const MOCK_MARKET_ITEMS = [
  {
    whole_id: 51,
    whole_name: "피오니",
    market_type: "양재",
    whole_img:
      "https://dhozawsgn245f.cloudfront.net/wholesales/wholesales_51/r_wholesales_51.jpg",
    whole_loc: "양재 꽃 시장 41-154호",
    items_on_sale: "호접란",
    is_liked: 0,
    favor_cnt: null,
    pageView: 0,
    recNum: 108,
    is_contact: 0,
  },
  {
    whole_id: 99,
    whole_name: "유원자재",
    market_type: "양재",
    whole_img:
      "https://dhozawsgn245f.cloudfront.net/wholesales/wholesales_99/r_wholesales_99.jpg",
    whole_loc: "양재 꽃 시장 43-209호",
    items_on_sale: null,
    is_liked: 0,
    favor_cnt: null,
    pageView: 0,
    recNum: 107,
    is_contact: 0,
  },
  {
    whole_id: 68,
    whole_name: "연화원",
    market_type: "양재",
    whole_img:
      "https://dhozawsgn245f.cloudfront.net/wholesales/wholesales_68/r_wholesales_68.jpg",
    whole_loc: "양재 꽃 시장 41-172호, 41-173호",
    items_on_sale: "유칼립투스,스카비오사,옥시페탈륨",
    is_liked: 0,
    favor_cnt: null,
    pageView: 0,
    recNum: 106,
    is_contact: 0,
  },
  {
    whole_id: 16,
    whole_name: "대상화훼",
    market_type: "양재",
    whole_img:
      "https://dhozawsgn245f.cloudfront.net/wholesales/wholesales_16/r_wholesales_16.jpg",
    whole_loc: "양재 꽃 시장 41-117호",
    items_on_sale: "거베라,리시안사스,장미",
    is_liked: 0,
    favor_cnt: null,
    pageView: 0,
    recNum: 105,
    is_contact: 0,
  },
  {
    whole_id: 112,
    whole_name: "꽃팜",
    market_type: "양재",
    whole_img:
      "https://dhozawsgn245f.cloudfront.net/wholesales/wholesales_112/r_wholesales_112.jpg",
    whole_loc: "양재 꽃 시장 41-248호",
    items_on_sale: null,
    is_liked: 0,
    favor_cnt: null,
    pageView: 0,
    recNum: 104,
    is_contact: 0,
  },
];

const MarketListViewWrapper = styled(Column)`
   min-height: 50vh;
   gap: 12px;
   overflow-y: scroll;
   padding: 8px 0px;
   -ms-overflow-style: none;
   scrollbar-width: none;
   &::-webkit-scrollbar {
      display: none;
   }
`;
